import server from "@/api/server";

/**
 * список заявок, которые готовы к встрече
 *
 * @param {Object} data
 * @param {string} data.page
 * @param {string} data.pageSize
 * @param {string} data.filter
 * @param {string} data.search_query
 */
async function getAllMeetings(data) {
  let res = await server.post("agent/agent/meeting/list", data);
  return res;
}

/**
 * meeting_state:
 * — upload_fls - ожидание загрузки паспортов учредителей
 * — upload_docs - ожидание загрузки документов
 * — reupload_docs - необходимо загрузить документы заново
 * — reupload_fls - необходимо загрузить паспорта учредителей заново
 * — process_fls - происходит обработка паспортов
 * — process_docs - происходит обработка документов
 *
 * флаги в доках:
 *
 * sended - флаг отправки (false при отклонении или не отправки; true - отправлена)
 * is_approved - флаг проверки документов (null - нет результата проверки или не отправлено;
 * false - отклонено; true - проверены и подтверждены)
 * comment - комментарий отклонения (тут в зависимости от is_approved)
 *
 */

async function getMeetingById(id) {
  let res = await server.post("/agent/agent/meeting/get", { id });
  return res;
}

/**
 * @param {Object} param0
 * @param {string} param0.oid - ид заявки
 * @param {string} param0.step - step - процесс открытия счёта:
 *   — send_fls - отправка паспортов учредителей
 *   — send_docs - отправка документов для открытия счёта
 *   — open - начать процесс
 */
async function processMeeting(data) {
  let res = await server.post("agent/agent/meeting/process", data);
  return res;
}

async function processMeetingSendFls(oid) {
  return processMeeting({ oid, step: "send_fls" });
}

async function processMeetingSendDocs(oid, data = null) {
  if (data) {
    return processMeeting({ oid, step: "send_docs", ...data });
  }

  return processMeeting({ oid, step: "send_docs" });
}

async function processMeetingOpen(data) {
  return processMeeting({ step: "open", ...data });
}

async function processMeetingSurvey(oid, data) {
  return processMeeting({
    oid,
    step: "survey_accopen",
    survey: {
      type: 'account_open',
      data: data
    }
  });
}

async function processMeetingTemplateFields(oid, data) {
  return processMeeting({
    oid,
    step: "template_fields",
    template_fields: data
  });
}

async function initMeeting(oid) {
  let res = await server.post("agent/agent/meeting/start", { oid });
  return res;
}

async function breakMeeting(oid) {
  let res = await server.post("agent/agent/meeting/break", { oid });
  return res;
}

async function addComment(oid, text) {
  let res = await server.post("agent/agent/meeting/add_comment", { oid, text });
  return res;
}

export async function mobileIdSendSms(oid, phone = null) {
  return server.post("agent/agent/meeting/send_mobile_id", { oid, phone });
}

export async function mobileIdVerifySms(oid, process_id, code) {
  return server.post("agent/agent/meeting/verify_mobile_id", { oid, process_id, code });
}

export {
  getAllMeetings,
  getMeetingById,
  processMeetingSendFls,
  processMeetingSendDocs,
  processMeetingOpen,
  processMeetingSurvey,
  processMeetingTemplateFields,
  initMeeting,
  breakMeeting,
  addComment
};
